import { Toast } from 'mint-ui';
import { errorMsgConfig } from './config'

// https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
if (!String.prototype.padStart) {
    String.prototype.padStart = function padStart(targetLength, padString) {
        targetLength = targetLength >> 0; //truncate if number, or convert non-number to 0;
        padString = String(typeof padString !== 'undefined' ? padString : ' ');
        if (this.length >= targetLength) {
            return String(this);
        } else {
            targetLength = targetLength - this.length;
            if (targetLength > padString.length) {
                padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
            }
            return padString.slice(0, targetLength) + String(this);
        }
    };
}


const ua = navigator.userAgent.toLowerCase();

export function isDef(v) {
    return v !== null && v !== undefined;
}

export function isObject(obj) {
    return obj !== null && typeof obj === 'object'
}

//判断是否为空对象null或者{}
export function isEmptyObj(obj) {
    for (let key in obj) {
        return false;
    }
    return true;
}

// 生成随机数
export function getMessageId(){
    let messageId = ''
    for(let i=0;i<8;i++){
      messageId += Math.floor((Math.random() * 10)).toString()
    }
    return messageId
}

export function getQueryObj(url = '') {
    let queryStr = url.split('?')[1];
    queryStr = decodeURI(queryStr);  // app传过来的时候解过一次，但是中文需要解码两次
    const pattern = new RegExp('(?:^|&)([^\=&]*)=([^&]*)', 'g');
    let r;
    let obj = Object.create(null);
    while((r = pattern.exec(queryStr)) != null) {
        obj[r[1]] = unescape(r[2]);
    } 
    return obj;
}

// 获取不包含传递信息的url
export function getPureUrl(url = ''){
  return url.split('?')[0]
}

export function getShortUrl(url){
  fetch(url).then(response => {
    return JSON.parse(response)
  })
}



/**
 *  url变量对象转字符串，eg: {a: 100,b: 200} => a=100&b=200
 * @param {Object} params 
 */
export function urlParamObject2String(params = {}) {
    let strArr = []
    for(let i in params) {
        strArr.push(`${i}=${params[i]}`);
    }
    return strArr.join('&');
}

export function devAlert(title, content){
    if(!arguments.length) return;

    if (process.env.NODE_ENV !== 'production') {
      if (arguments.length == 1) {
        alert(`${JSON.stringify(title)}`);
      } else {
        alert(`${title}: ${JSON.stringify(content)}`);
      }
    }
}

export function toast(msg) {
   Toast(String(msg));
}

export function toastError(error) {
    if (!error) return;

    toast(getErrorMessage(error));
}

export function getErrorMessage(error) {
    if (!error) return;
    if (typeof(error) == 'string') return error;

    let errorCode = error.errorCode;
    let external = error.external;
    let msg = (external && (external.msg || external.message)) || 
            errorMsgConfig[errorCode] || error.msg || error.message || error.errorMsg || 
            error.returnMsg || error.errorMessage || "系统繁忙，请稍后再试";
    return msg;
}


// 延时调用某函数
export function callDelay(method, context, delay = 300, params) {
    setTimeout(() => {
        method.call(context, params);
    }, delay);
}

export function setItem(key, value){
   localStorage.setItem(key, JSON.stringify(value)) 
}

export function getItem(key){
   let value = localStorage.getItem(key);
   try{
      return JSON.parse(value);
   }catch(err) {
      return value;
   }
}

export function setSession(key, value){
   sessionStorage.setItem(key, JSON.stringify(value)) 
}

export function getSession(key){
   let value = sessionStorage.getItem(key);
   try{
      return JSON.parse(value);
   }catch(err) {
      return value;
   }
}

// 生成带有命名空间的getSession函数
export function getSessionWithNsFun(namespace) {
    return function (key) {
        return getSession(namespace+'/'+key);
    }
}

// 生成带有命名空间的setSession函数
export function setSessionWithNsFun(namespace) {
    return function (key, value) {
        setSession(namespace+'/'+key, value);
    }
}

export function  parseURL(url) { 

    url = url || location.href;
    var a = document.createElement('a'); 
    a.href = url; 
    const parseObj =  { 
        source: url, 
        protocol: a.protocol.replace(':',''), 
        host: a.hostname, 
        port: a.port, 
        query: a.search, 
        params: (function(){ 
            var ret = {}, 
            seg = a.search.replace(/^\?/,'').split('&'), 
            len = seg.length, i = 0, s; 
            for (;i<len;i++) { 
                if (!seg[i]) { continue; } 
                s = seg[i].split('='); 
                ret[s[0]] = s[1]; 
            } 
            return ret; 
        })(), 
        file: (a.pathname.match(/\/([^\/?#]+)$/i) || [,''])[1], 
        hash: a.hash.replace('#',''), 
        path: a.pathname.replace(/^([^\/])/,'/$1'), 
        relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [,''])[1], 
        segments: a.pathname.replace(/^\//,'').split('/') 
    }; 

    parseObj.hostFull = `${parseObj.protocol}://${parseObj.host}`;
    if(parseObj.port) {
        parseObj.hostFull += `:${parseObj.port}`;
    }
    return parseObj;
}

/**
 * 由于历史原因，生产环境上云端返回的链接有时候是18443端口，而微信公众号绑定的域名是80端口的，所以需要做一层转化
 * @param {String} url 需要分享的url
 */
export function formatShareUrl(url) {
    if (!url) return ''
    let res = url.replace(':18443', '')
    return res
}


// 判断是否是支付宝
export function isAlipay() {
   return ua.indexOf('alipayclient') !== -1
};


// 判断是否是微信
export function isWeixin() {
   return ua.indexOf('micromessenger') !== -1
};


// 判断是否是ios浏览器
export function isIos() {
    let u = navigator.userAgent;
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

// 获取ios系统主版本
export function getIosMainVersion() {
    const u = navigator.userAgent; 
    const ver = u.match(/CPU iPhone OS (\d+)_/);
    
    return ver && parseInt(ver[1]);
}

//判断是safari浏览器
export function isSafari() {
    return  /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
}

/**
 * 是否处于四格(云朵2.x)的webview环境
 */
export function isInSegiu(){
    return document.cookie.includes('segiupt') ? true : false;
}
/**
 * 是否处于云邻社区APP（云朵3.x）的webview环境
 */
export function isInCloudApp(){
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.includes('cloudycommunity');
}

/**
 * 是否为微信
 */
 export function isWechat(){
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.includes('micromessenger');
}

// 格式化时间
export function formatTime(date, formatter = 'yyyy-MM-dd') {
    if (!date) return;

    if (typeof(date) === 'string' || typeof(date) === 'number') {
        date = new Date(date);
    }
    const o = { 
         "M+" : date.getMonth()+1,     
         "d+" : date.getDate(),     
         "h+" : date.getHours(),     
         "m+" : date.getMinutes(),    
         "s+" : date.getSeconds(),     
         "q+" : Math.floor((date.getMonth()+3)/3), 
         "S" : date.getMilliseconds()    
     }; 
     if (/(y+)/.test(formatter)) 
        formatter = formatter.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length)); 


     for (let k in o) {
        if (new RegExp("("+ k +")").test(formatter))  {
            formatter = formatter.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (o[k]+'').padStart(2, '0'));  
        }  
     }

     return formatter; 
}


function toLocalDate(date) {
    if (date === '') {
      return null
    }
  
    if (date instanceof Date) {
      return date
    }
  
    let dateStr = date.replace(/-/g, '/')
    dateStr = dateStr.replace(/[Tt]/g, ' ')
    dateStr = dateStr.replace(/[Zz]/g, '')
    dateStr = dateStr.replace(/\..+/g, '')
  
    const result = new Date(dateStr)
  
    if (result && result.getTime && result.getDate()) {
      return result
    } else {
      return null
    }
  }
  function toUTCDate(date) {
    const localDate = toLocalDate(date)
    const SECONDS_PER_MINUTE = 60
  
    if (!localDate) return localDate
  
    const offset = (new Date()).getTimezoneOffset()
  
    return new Date(localDate.getTime() + offset * SECONDS_PER_MINUTE * 1000)
  }
  export function formatTimeNew(dateStr, format, isUTC = false) {
    let formatStr
    const DEFAULT_FORMAT = 'yyyy-MM-dd hh:mm:ss'
    let utc = false
  
    if (typeof format === 'undefined') {
      formatStr = DEFAULT_FORMAT
    } else if (typeof format === 'boolean') {
      utc = format
      formatStr = DEFAULT_FORMAT
    } else {
      formatStr = format
      if (typeof isUTC !== 'undefined') {
        utc = isUTC
      }
    }
    let date
    if (utc) {
      date = toUTCDate(dateStr)
    } else {
      date = toLocalDate(dateStr)
    }
    // dateStr 参数不合法（不能转为Date类型）
    if (!date) {
      return '-'
    }
  
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hours = date.getHours()
    const minutes = date.getMinutes()
    const seconds = date.getSeconds()
    const milliseconds = date.getMilliseconds()
  
    const zeroPrefix = (num, digits = 2) => `0${num}`.slice(-digits)
  
    return formatStr
      .replace(/yyyy/g, `${year}`)
      .replace(/MM/g, zeroPrefix(month))
      .replace(/dd/g, zeroPrefix(day))
      .replace(/yy/g, `${year}`)
      .replace(/d/g, `${day}`)
      .replace(/hh/g, zeroPrefix(hours))
      .replace(/mm/g, zeroPrefix(minutes))
      .replace(/ss/g, zeroPrefix(seconds))
      .replace(/SSS/g, `${milliseconds}`.slice(0, 3))
  }

//将字符串格式转成日期格式
export function parseStrToDate(dateStr) {
    if (typeof(dateStr) === 'object') return dateStr;
    if (typeof(dateStr) === 'number') return new Date(dateStr);

    const regStr = dateStr.replace(/\d+/g, w => {
        return `(\\d{${w.length}})`;
    });
    const dateReg = new RegExp(regStr);

    let res = dateStr.match(dateReg);
    if (!res) return;

    res = res.slice(1);
    res[1] = parseInt(res[1])-1;

    const date = new Date(...res);
    return date;
}

export function queryModuleData(moduleName) {
    return new Promise((resolve,reject) => {
        jsbridge.excMethod('communityModule','queryModuleData',{
            module: moduleName
        },data => {
            let ret = typeof data == 'string' ? JSON.parse(data) : data;
            resolve(ret); 
        })
    })

}

/**
 *  async/await 错误处理
 */
export const awaitWrap = (promise) => {
    return promise
        .then(data => [null, data])
        .catch(err => [err, null]);
}


/**
 *  获取最新的父级节点
 * @param {*} node 
 */
export const getNearestParentNode = (node, nodeName)=> {
    let aNode = null;
    while(node) {
        if(node.nodeName == nodeName) {
            aNode = node;
            node = null;
        } else {
            node = node.parentElement;
        }   
    }
    return aNode;
}



// WEBPACK FOOTER //
// ./src/utils/index.js